import { ColDef, ColGroupDef, MenuItemDef } from "ag-grid-community";
import { ColumnTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { ItemBagType } from "constants/product-collection";
import { getAllocationDimensionMenuItems } from "helpers/door-collection";
import { IBagRow } from "helpers/table-bag";
import { fromJS, Map } from "immutable";

export enum CopyCutPasteActions {
    Cut = "cut",
    Copy = "copy",
    Paste = "paste",
}

export interface IAllocationClipboardState {
    path: UnitsPath;
    action: CopyCutPasteActions;
    srcIsDoor: boolean;
}
export type UnitsPath = [string, string] | [string];
export const copyAndPasteUnits = (item: Map<string, any>, src: UnitsPath, dest: UnitsPath, tableType: ItemBagType) => {
    if (src.length !== dest.length) {
        throw "Src path and Dest path don't match";
    }
    if (dest.every((v, i) => v === src[i])) {
        return item; // We are copy/pasting on the exact same place
    }
    const table = item.get(tableType);
    if (!table) {
        return item; // We don't have a table to copy from/paste to
    }
    const tableRows: IBagRow[] = table.r || table.get("r")?.toJS();
    if (!tableRows) {
        return item;
    }
    const filteredTableRows = tableRows.filter(({ c }) => dest.some((v, i) => v !== c[i]));
    return item.setIn(
        [tableType, "r"],
        fromJS(
            filteredTableRows.reduce(
                (acc, { c }) =>
                    src.every((v, i) => v === c[i])
                        ? acc.concat([{ c: dest.concat(c.filter((_, i) => i >= dest.length)) }])
                        : acc,
                filteredTableRows
            )
        )
    );
};

export const cutAndPasteUnits = (item: Map<string, any>, src: UnitsPath, dest: UnitsPath, tableType: ItemBagType) => {
    const copyAndPasteResult = copyAndPasteUnits(item, src, dest, tableType);
    if (copyAndPasteResult === item) {
        return item;
    }
    return copyAndPasteResult.setIn(
        [tableType, "r"],
        copyAndPasteResult.getIn([tableType, "r"]).filter((row) => src.some((v, i) => v !== row.getIn(["c", i])))
    );
};

export const calculatePathWithColDef = (colDef: ColDef | ColGroupDef): UnitsPath => {
    if ((colDef as ColGroupDef).groupId) {
        return [(colDef as ColGroupDef).groupId];
    }
    const { groupId, doorId }: { groupId: string; doorId: string } = (colDef as ColDef).cellRendererParams;
    const result: UnitsPath = [doorId];
    groupId && result.unshift(groupId); // Had to do it this way because TypeScript wouldn't allow to use destructuring operator
    return result;
};

export const copyCutPasteMenuHandler = (
    clipboardEmpty: boolean,
    srcIsDoor: boolean,
    column,
    action
): MenuItemDef[] | undefined => {
    const colDef: ColDef | ColGroupDef = column.getColDef();
    if ((colDef as ColDef).type === ColumnTypes.DoorBulkQuantity) {
        return getAllocationDimensionMenuItems({
            enablePaste: !clipboardEmpty && srcIsDoor,
            path: calculatePathWithColDef(colDef),
            actionCallback: action,
        });
    } else if ((colDef as ColGroupDef).groupId) {
        return getAllocationDimensionMenuItems({
            enablePaste: !clipboardEmpty && !srcIsDoor,
            path: calculatePathWithColDef(colDef),
            actionCallback: action,
        });
    }
};
